import { Navigate } from "react-router-dom";
import { Helpers, Routes } from "utils";
import { useApp } from "context";

export const Google = () => {
  const { service } = useApp();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const code = urlParams.get("code");

  if (Helpers.hasValue(code)) {
    service.google.accessToken(code ?? "");
  }

  return <Navigate to={Routes.patient.home} replace />;
};
